import React from "react"
import { Link, useTranslation} from 'gatsby-plugin-react-i18next'

import font from "../../fonts/fonts.module.scss"
import styled from "styled-components"

import { Button } from "../buttons"
import Slider from "react-slick"
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { device } from "../device"

import Card from "./vinhoCard"
import linkify from "../../custom/linkify"

import seta from "../../images/setaDDark.svg"

const VinhosCardList = ({ data, vinho, full }) => {
  const {t} = useTranslation(['vinhos'])
  const breakpoints = useBreakpoint()

  const settings = {
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    pauseOnHover: false,
    swipeToSlide: true,
    infinite:false,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4
        }
      }
    ]
  }

  // SORT VINHOS ASC
  // switch (vinho) {
  //   case 'bairrada': 
  //     sortedWines = t('docs.bairrada', {returnObjects: true}).sort((a, b) => a.nome.localeCompare(b.nome))
  //     break
  //   case 'dao':
  //     sortedWines = t('docs.dao', {returnObjects: true}).sort((a, b) => a.nome.localeCompare(b.nome))
  //     break
  //   case 'douro':
  //     sortedWines = t('docs.douro', {returnObjects: true}).sort((a, b) => a.nome.localeCompare(b.nome))
  //     break
  //   case 'setubal':
  //     sortedWines = t('docs.setubal', {returnObjects: true}).sort((a, b) => a.nome.localeCompare(b.nome))
  //     break
  //   case 'palmela':
  //     sortedWines = t('docs.palmela', {returnObjects: true}).sort((a, b) => a.nome.localeCompare(b.nome))
  //     break
  //   case 'porto':
  //     sortedWines = t('docs.porto', {returnObjects: true}).sort((a, b) => a.nome.localeCompare(b.nome))
  //     break
  //   case 'tejo':
  //     sortedWines = t('docs.tejo', {returnObjects: true}).sort((a, b) => a.nome.localeCompare(b.nome))
  //     break
  //   case 'verde':
  //     sortedWines = t('docs.verde', {returnObjects: true}).sort((a, b) => a.nome.localeCompare(b.nome))
  //     break
  //   case 'lua-cheia':
  //     sortedWines = t('docs.luacheia', {returnObjects: true}).sort((a, b) => a.nome.localeCompare(b.nome))
  //     break
  //   case 'azul-portugal':
  //     sortedWines = t('docs.azulportugal', {returnObjects: true}).sort((a, b) => a.nome.localeCompare(b.nome))
  //     break
  //   default:
  //     return '';
  // }  

  data.sort((a, b) => a.nome.localeCompare(b.nome))

  return(
    <StyledVinhos>
        {!full ? 
          <>
            <div className='all'>
            {!breakpoints.mobile &&
              <>
                {data.slice(0, 9).map((data, i)=>(
                  <Link as={Button} key={"cardList" + i} styleless fullHeight to={"/vinhos/" + linkify(data.regiao, data.nome)}>
                    <Card data={data}/>
                  </Link>  
                )).sort(data.nome)}

                {(() => {
                  switch (vinho) {
                    case 'bairrada':
                      return (
                        <Link to={t('verMais.docs.bairradaLnk')} className="verMais">
                          <img src={seta} alt="Seta para ver Mais" className="setaImg"/>
                          <h4 className={font.aGGD}>{t('verMais.docs.bairrada')}</h4>
                        </Link>
                      )
                    case 'dao':
                      return (
                        <Link to={t('verMais.docs.daoLnk')} className="verMais">
                          <img src={seta} alt="Seta para ver Mais" className="setaImg"/>
                          <h4 className={font.aGGD}>{t('verMais.docs.dao')}</h4>
                        </Link>
                      )
                    case 'douro':
                      return (
                        <Link to={t('verMais.docs.douroLnk')} className="verMais">
                          <img src={seta} alt="Seta para ver Mais" className="setaImg"/>
                          <h4 className={font.aGGD}>{t('verMais.docs.douro')}</h4>
                        </Link>
                      )
                    case 'setubal':
                      return (
                        <Link to={t('verMais.docs.setubalLnk')} className="verMais">
                          <img src={seta} alt="Seta para ver Mais" className="setaImg"/>
                          <h4 className={font.aGGD}>{t('verMais.docs.setubal')}</h4>
                        </Link>
                      )
                    case 'palmela':
                      return (
                        <Link to={t('verMais.docs.palmelaLnk')} className="verMais">
                          <img src={seta} alt="Seta para ver Mais" className="setaImg"/>
                          <h4 className={font.aGGD}>{t('verMais.docs.palmela')}</h4>
                        </Link>
                      )
                    case 'porto':
                      return (
                        <Link to={t('verMais.docs.portoLnk')} className="verMais">
                          <img src={seta} alt="Seta para ver Mais" className="setaImg"/>
                          <h4 className={font.aGGD}>{t('verMais.docs.porto')}</h4>
                        </Link>
                      )
                    case 'tejo':
                      return (
                        <Link to={t('verMais.docs.tejoLnk')} className="verMais">
                          <img src={seta} alt="Seta para ver Mais" className="setaImg"/>
                          <h4 className={font.aGGD}>{t('verMais.docs.tejo')}</h4>
                        </Link>
                      )
                    case 'verde':
                      return (
                        <Link to={t('verMais.docs.verdeLnk')} className="verMais">
                          <img src={seta} alt="Seta para ver Mais" className="setaImg"/>
                          <h4 className={font.aGGD}>{t('verMais.docs.verde')}</h4>
                        </Link>
                      )
                    default:
                      return '';
                  }
                })()}
              </>
            }
            {breakpoints.mobile &&
            <Slider {...settings}>
              {data.slice(0, 9).map((data, i)=>(
                <Link as={Button} key={"cardList" + i} styleless fullHeight to={"/vinhos/" + linkify(data.regiao, data.nome)}>
                  <Card data={data}/>
                </Link>
              ))}
            </Slider>
            }
            </div>
          </> : 
          <>
            <div className='category'>
              {data.map((data, i)=>(
                <Link as={Button} key={"cardList" + i} styleless fullHeight to={"/vinhos/" + linkify(data.regiao, data.nome)}>
                  <Card data={data}/>
                </Link>
              ))}
            </div>
          </>
        }
    </StyledVinhos>
  )
}

export default VinhosCardList

const StyledVinhos = styled.div`
  position: relative;
  margin: 14px 0;

  .all{
    @media ${device.desktop}{
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      grid-gap: 14px;
    }
  }

  .category{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 14px;
    padding: 0 15px;

    @media ${device.desktop}{
      grid-template-columns: repeat(5, 1fr);
      padding:0;
    }
  }

  .verMais{
    position: relative;
    border: 1px solid #71584a;
    padding: 14px;
    color: #71584a;

    .setaImg{
      margin-bottom: 15px;
    }
  
    h4{
        font-size:19px;
      }
  }

  .slick-track{
    display:flex;
  }

  .slick-slide{
    margin: 0 10px;

    &>div, a{
      height:100%;
    }
  }

  .cardTitle{
    font-size: 20px !important;
    height: 100% !important;

    @media ${device.desktop}{
      font-size: 24px !important;
    }
  }

  .cardYear{
    font-size:10px !important;

    @media ${device.desktop}{
      font-size:14px !important;
    }
  }
`